import './Queues.scss';
import { v4 as uuid } from 'uuid';
import { QueueManagementConstants, QueuesTracks } from './QueueManagementConstants';
import { ToastType } from 'modules/application/misc/ToastService';
import { debounce } from 'data/function';
import { AttendanceFeatures } from '../AttendanceFeatures';
export class QueuesController {
    static $inject = ['application', '$scope', 'DeskConfigurationService', 'LoadingService', 'AlertService', 'SegmentService', 'QueuesService', '$translate', 'PermissionsService', 'TeamService', '$state'];
    constructor(application, $scope, DeskConfigurationService, LoadingService, AlertService, SegmentService, QueuesService, $translate, PermissionsService, TeamService, $state) {
        'ngInject';
        this.application = application;
        this.$scope = $scope;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.AlertService = AlertService;
        this.SegmentService = SegmentService;
        this.QueuesService = QueuesService;
        this.$translate = $translate;
        this.PermissionsService = PermissionsService;
        this.TeamService = TeamService;
        this.$state = $state;
        this.open = false;
        this.validQueueName = true;
        this.nameRequired = true;
        this.queueName = '';
        this.teams = [];
        this.currentState = QueueManagementConstants.STATES.VIEWING;
        this.attendantsTake = 999999;
        this.allQueueTake = 999999;
        this.take = 100;
        this.skip = 0;
        this.filter = '';
        this.inputTextSearchQueues = '';
        this.isManagerView = true;
        this.isViewing = QueueManagementConstants.STATES.VIEWING;
        this.isAdding = QueueManagementConstants.STATES.ADDING;
        this.isEdit = QueueManagementConstants.STATES.EDITING;
        this.searchQueue = async (event) => {
            this.setIsLoading(true);
            this.inputTextSearchQueues = event.detail.value;
            if (this.inputTextSearchQueues) {
                this.filterQueues();
            }
            else {
                this.filteredQueues = this.allQueues.slice();
                this.filteredQueuesCount = this.allQueuesCount;
                this.checkLoadMoreStatus();
            }
            this.setIsLoading(false);
            this.SegmentService.createBotTrack(QueuesTracks.QUEUES_SEARCHED, this.application, this.trackPayload);
        };
        this.changeQueueName = async (event) => {
            this.queueName = await event?.target.value.trim();
            this.validQueueName = true;
            this.nameRequired = false;
            if (this.queueName.length === 0) {
                this.nameRequired = true;
            }
        };
        this.toggleModal = () => {
            this.open = !this.open;
            this.nameRequired = false;
            this.queueName = '';
        };
        this.verifyQueueExists = async () => {
            try {
                const { items } = await this.QueuesService.filterQueues(this.queueName.trim(), 0, this.allQueueTake);
                const queueFilter = items.find(queue => {
                    return queue.name.toLowerCase().trim() === this.queueName.toLowerCase().trim();
                });
                if (queueFilter) {
                    return true;
                }
            }
            catch (error) {
                if (error.code !== 67) {
                    return true;
                }
            }
            return false;
        };
        this.addNewQueue = async () => {
            this.isLoading = true;
            let toastMessageReference;
            let toastType;
            let queue = { name: this.queueName, isActive: true };
            try {
                if (await this.verifyQueueExists()) {
                    this.validQueueName = false;
                    return;
                }
                queue = await this.QueuesService.save(queue);
                toastType = ToastType.Success;
                this.toggleModal();
                this.SegmentService.createApplicationTrack({
                    trackEvent: QueuesTracks.QUEUE_ADDED,
                    application: this.application,
                    payload: {},
                });
                this.$state.go('auth.application.detail.attendance.queueManagement.queue', { id: queue.id });
            }
            catch (error) {
                toastMessageReference = await this.$translate('utils.errorMsg.112');
                toastType = ToastType.Danger;
            }
            finally {
                this.isLoading = false;
                await this.QueuesService.showToast(toastMessageReference, toastType);
            }
        };
    }
    async $onInit() {
        const isQueueManagementMfeEnabled = await AttendanceFeatures.isQueueManagementMfeEnabled();
        if (isQueueManagementMfeEnabled) {
            this.$state.go('auth.application.detail.attendance.desk.queueManagement');
            return;
        }
        this.allQueues = [];
        this.filteredQueues = [];
        this.canEditQueue = await this.PermissionsService.hasPermissions(QueueManagementConstants.WRITE, QueueManagementConstants.DESK);
        this.canSeeQueue = await this.PermissionsService.hasPermissions(QueueManagementConstants.READ, QueueManagementConstants.DESK);
        this.isEditing = false;
        this.trackPayload = { source: QueuesTracks.SOURCE.PORTAL };
        this.debouncedSearch = debounce(this.searchQueue, 500);
        this.SegmentService.createBotTrack(QueuesTracks.PAGE_OPENED, this.application, this.trackPayload);
        await this.getAllAttendants();
        await this.getQueues();
        this.setIsLoading(false);
        const text = await this.$translate('modules.application.detail.attendance.queue-management.helperLink.title');
        const link = await this.$translate('modules.application.detail.attendance.queue-management.helperLink.link');
        this.helperLink = { text, link };
    }
    setCurrentState(state) {
        this.currentState = state;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    async filterQueues() {
        this.filteredQueues = [];
        this.filteredQueuesCount = 0;
        try {
            const { items, total } = await this.QueuesService.filterQueues(this.inputTextSearchQueues, this.filteredQueues.length, this.take);
            const queues = this.mapQueues(items);
            this.filteredQueues.push(...queues);
            this.filteredQueuesCount = total;
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.checkLoadMoreStatus();
        }
    }
    mapQueues(items) {
        let queues;
        queues = items ? items.map((item) => {
            item.numberAttendants = (this.teams.filter((a) => (a.teams?.includes(item.name)))).length;
            return item;
        }) : [];
        return queues;
    }
    checkLoadMoreStatus() {
        if (this.isFilterMode()) {
            this.canLoadMore = this.filteredQueues.length < this.filteredQueuesCount;
        }
        else {
            this.canLoadMore = this.allQueues.length < this.allQueuesCount;
        }
    }
    isFilterMode() {
        if (this.inputTextSearchQueues == undefined || this.inputTextSearchQueues === '') {
            return false;
        }
        return true;
    }
    async clearSearch() {
        this.inputTextSearchQueues = '';
        this.currentState = QueueManagementConstants.STATES.VIEWING;
        this.filteredQueues = this.allQueues.slice();
        this.filteredQueuesCount = this.allQueuesCount;
        this.checkLoadMoreStatus();
        this.SegmentService.createBotTrack(QueuesTracks.CLEAR_SEARCH, this.application, this.trackPayload);
    }
    async getQueues() {
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        this.canLoadMore = false;
        try {
            const { items, total } = await this.QueuesService.getQueues(this.skip, this.take);
            this.allQueues = this.mapQueues(items);
            this.filteredQueues = this.allQueues.slice();
            this.allQueuesCount = total;
            this.filteredQueuesCount = this.allQueuesCount;
        }
        catch (e) {
            this.allQueues = [];
            this.allQueuesCount = 0;
            this.filteredQueues = [];
            this.filteredQueuesCount = 0;
        }
        finally {
            this.setIsLoading(false);
            this.checkLoadMoreStatus();
        }
    }
    async getAllAttendants() {
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        try {
            const { items } = await this.TeamService.getAttendants(this.filter, this.skip, this.attendantsTake);
            const team = items;
            this.teams.push(...team);
        }
        catch (e) {
            this.teams = [];
        }
        this.setIsLoading(false);
    }
    async createQueue() {
        if (this.currentState === QueueManagementConstants.STATES.ADDING || this.currentState === QueueManagementConstants.STATES.EDITING) {
            return;
        }
        this.setCurrentState(QueueManagementConstants.STATES.ADDING);
        const title = await this.$translate('queue-management.queues.queueName');
        const newQueue = {
            id: uuid(),
            title: `${title} ${this.filteredQueues.length + 1}`,
            isActive: true,
            opened: true,
        };
        this.filteredQueues = this.filteredQueues.concat(newQueue);
        const input = document.getElementById(`queue-title-${this.filteredQueues.length - 1}`);
        if (input) {
            input.focus();
        }
        this.SegmentService.createBotTrack(QueuesTracks.QUEUE_ADDED, this.application, this.trackPayload);
    }
    addQueue() {
        if (this.currentState === QueueManagementConstants.STATES.ADDING || this.currentState === QueueManagementConstants.STATES.EDITING) {
            return;
        }
        this.SegmentService.createBotTrack(QueuesTracks.ADD_QUEUE_CLICKED, this.application);
        if (this.filteredQueues.length == 0) {
            this.filteredQueues.push({});
        }
        else {
            const lastQueue = this.filteredQueues[this.filteredQueues.length - 1];
            if (lastQueue.hasOwnProperty('id')) {
                this.filteredQueues.push({});
            }
        }
    }
    clearQueueList(data) {
        if (data.id) {
            return;
        }
        this.filteredQueues.pop();
    }
    async saveQueue(data) {
        this.LoadingService.startLoading();
        let queue;
        let toastMessageReference;
        let toastType;
        queue = {
            id: uuid(),
            ...data,
        };
        toastMessageReference = this.currentState === QueueManagementConstants.STATES.ADDING
            ? 'queue-management.queues.confirmAddQueue'
            : 'queue-management.queues.confirmEdit';
        try {
            await this.QueuesService.save(queue);
            this.SegmentService.createBotTrack(QueuesTracks.QUEUE_SAVED, this.application, this.trackPayload);
            toastType = ToastType.Success;
        }
        catch (ex) {
            toastMessageReference = 'modules.application.detail.attendance.queue-management.warning';
            toastType = ToastType.Danger;
        }
        finally {
            this.LoadingService.stopLoading();
            await this.QueuesService.showToast(toastMessageReference, toastType);
            this.setIsLoading(false);
        }
    }
    async confirmDelete(queue) {
        if (queue.numberAttendants > 0) {
            let toastMessageReference;
            let toastType;
            toastType = ToastType.Danger;
            toastMessageReference = 'queue-management.queues.warnningDeleteAttendant';
            await this.QueuesService.showToast(toastMessageReference, toastType);
            return;
        }
        try {
            const modalTitle = await this.$translate('modules.application.detail.attendance.queue-management.builder.confirmDeleteTitle');
            const modalBody = await this.$translate('modules.application.detail.attendance.queue-management.builder.confirmDeleteBody', { name: queue.name });
            const confirm = await this.$translate('queue-management.actions.exclude');
            const cancel = await this.$translate('queue-management.actions.abortAction');
            await this.AlertService.show({
                title: modalTitle,
                body: modalBody,
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: cancel,
                    confirm: confirm,
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: () => this.delete(queue),
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async delete(queue) {
        let toastMessageReference;
        let toastType;
        try {
            this.LoadingService.startLoading();
            await this.QueuesService.delete(queue);
            this.filteredQueues = this.filteredQueues.filter(obj => obj.id !== queue.id);
            toastMessageReference = 'queue-management.queues.confirmRemoveQueue';
            toastType = ToastType.Success;
            await this.getQueues();
            this.SegmentService.createBotTrack(QueuesTracks.QUEUE_DELETED, this.application, this.trackPayload);
        }
        catch (e) {
            toastMessageReference = 'utils.errorMsg.113';
            toastType = ToastType.Danger;
        }
        finally {
            this.LoadingService.stopLoading();
            await this.QueuesService.showToast(toastMessageReference, toastType);
        }
    }
    async fetchQueues() {
        if (this.isLoading) {
            return;
        }
        this.setIsLoading(true);
        try {
            const { items, total } = await this.QueuesService.getQueues(this.skip, this.take);
            this.allQueues = this.mapQueues(items);
            this.filteredQueues = this.allQueues.slice();
            this.allQueuesCount = total;
            this.filteredQueuesCount = this.allQueuesCount;
            this.checkLoadMoreStatus();
            this.setIsLoading(false);
        }
        catch (e) {
            console.error(e);
        }
    }
    async loadMore() {
        if (this.isFilterMode()) {
            let queues;
            const { items, total } = await this.QueuesService.filterQueues(this.inputTextSearchQueues, this.filteredQueues.length, this.take);
            queues = this.mapQueues(items);
            this.filteredQueues.push(...queues);
            this.filteredQueuesCount = total;
            this.checkLoadMoreStatus();
        }
        else {
            const { items, total } = await this.QueuesService.getQueues(this.allQueues.length, this.take);
            let queues;
            queues = this.mapQueues(items);
            this.allQueues.push(...queues);
            this.allQueuesCount = total;
            this.filteredQueuesCount = total;
            this.filteredQueues = this.allQueues.slice();
            this.checkLoadMoreStatus();
        }
    }
}
QueuesController.$inject = ['application', '$scope', 'DeskConfigurationService', 'LoadingService', 'AlertService', 'SegmentService', 'QueuesService', '$translate', 'PermissionsService', 'TeamService', '$state'];
